module.exports = __webpack_public_path__ + "media/assets/Clients-3c44ebe25283d5bd3222ccf5e7b81302.svg";